var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Agenda"}},[_c('div',{staticClass:"con-tab-ejemplo"},[_c('capacitacionesAgenda')],1)]),_c('vs-tab',{attrs:{"label":"Temas de capacitación"}},[_c('div',{staticClass:"con-tab-ejemplo"},[_c('capacitaciones')],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }